import React, { useState, useEffect } from "react";
import "../../../../utils/Css/Marketing.css";
import "../../../../utils/Css/Campagne.css";
import { useNavigate } from "react-router-dom";
import { Card, Button, Modal } from "react-bootstrap";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-datetime/css/react-datetime.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import "react-datepicker/dist/react-datepicker.css";
import CampagnEmailService from "./../../../../services/MarketingService/CampagnEmailService";
import "react-datetime/css/react-datetime.css";
import { TextField } from "@material-ui/core";
import getCurrentUserId from "../../../../reduxSaga/sagas/requests/currentUserId";
function PageCampagneE() {
  const [data, setData] = useState([]);

  const [statutsData, setStatutsData] = useState([]);

  const [debutDate, setdebutDate] = useState(null);
  const [finDate, setfinDate] = useState(null);

  const [inputValue, setInputValue] = useState(null);
  const [buttonDisabled, setButtonDisabled] = useState(true);

  const [success, setSuccess] = useState(null);
  const [erreur, setErreur] = useState(null);

  // state for filter parameters
  const [filter, setFilter] = useState({
    nom: "",
    statut: "",
    debutDate: "",
    finDate: "",
  });

  // Fonction pour exporter les données filtrées au format CSV
  const handleExportCSV = () => {
    const currentDateTime = new Date().toISOString().replace(/[-:.]/g, "");
    const headerValue = "Nom,Type,Canal de diffusion";
    const csvData = data.map(
      (item) => `${item.nom},${item.type},${item.canalDiffusion}`
    );
    const csvContent = `${headerValue}\n${csvData.join("\n")}`;
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `Campagne_Reseaux_Sociaux_${currentDateTime}.csv`;
    link.click();
  };

  //Delete modal
  // Gérer les changements de valeur dans l'entrée
  const handleInputChangeDelete = (event) => {
    setInputValue(event.target.value);

    // Désactiver le bouton de suppression si l'entrée est vide ou différente de "DELETE"
    if (event.target.value !== "DELETE") {
      setButtonDisabled(true);
    } else {
      setButtonDisabled(false);
    }
  };
  //DeleteModal
  const [show, setShow] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const handleClose = () => setShow(false);

  const handleDeleteCampagne = (row) => {
    setSelectedRow(row);
    setShow(true);
  };

  const handleConfirmDelete = async () => {
    try {
      await CampagnEmailService.supprimerCampagneEmail(selectedRow.id);
      const newData = data.filter((item) => item.id !== selectedRow.id);
      setData(newData);
      setShow(false);
      // Effacer la valeur de l'input "DELETE" après le clique sur le button supprimer
      setInputValue("");
    } catch (error) {
      console.error(error);
    }
  };
  //useEffect
  useEffect(() => {
    AfficherListStatus();
    fetchData();
  }, []);
  useEffect(() => {
    if (success) {
      const timeoutId = setTimeout(() => {
        setSuccess(null);
      }, 2000);
      return () => clearTimeout(timeoutId);
    }
    /* if (erreur) {
      const timeoutId = setTimeout(() => {
        setErreur(null);
      }, 2000);
      return () => clearTimeout(timeoutId);
    } */
  }, [success]);

  //methode pour afficher status
  const AfficherListStatus = async () => {
    try {
      CampagnEmailService.AfficherListStatus()
        .then((response) => {
          setStatutsData(response.data.success);
        })
        .catch((error) => {
          console.log("error", error);
        });
    } catch (error) {
      console.log(error);
      setErreur(error.message);
    }
  };

  const fetchData = () => {
    try {
      CampagnEmailService.AfficherListCampagneEmail(getCurrentUserId())
        .then((response) => {
          setData(response.data.success);
        })
        .catch((error) => {
          console.log("error", error);
        });
    } catch (error) {
      console.log(error);
      setErreur(error.message);
    }
  };
  //pagination
  const options = {
    sizePerPage: 4,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
    paginationPosition: "bottom",
  };

  //filtre
  // update filter parameters on change
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilter((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // filter date debut
  const onChangeStartDate = (event) => {
    setFilter((prevState) => ({
      ...prevState,
      debutDate: event.target.value,
    }));
  };

  // filter date Fin
  const onChangeEndDate = (event) => {
    setFilter((prevState) => ({
      ...prevState,
      finDate: event.target.value,
    }));
  };
  // filter data
  const filterData = () => {
    try {
      // console.log("filter",filter)
      // CampagnEmailService.getCampagneEmailByFiltre(
      //   filter.nom,
      //   filter.statut,
      //   filter.debutDate,
      //   filter.finDate
      // ).then((response) => {
      //   setData(response.data);
      // }).catch((error) => {
      //   console.log(error);
      // })
    } catch (error) {
      console.log(error);
      setErreur(error.message);
    }
  };

  // useEffect to fetch data based on filter parameters
  useEffect(() => {
    if (filter) {
      filterData();
    } else {
      fetchData();
    }
  }, [filter]);

  //routes
  const navigate = useNavigate();

  // columns-campagne
  const columns = [
    {
      dataField: "creationDate",
      text: "Date creation",
      formatter: (cell) => {
        const options = { year: "numeric", month: "2-digit", day: "2-digit" };
        const date = new Date(cell);
        return date.toLocaleDateString("fr-FR", options).replace(/\//g, "-");
      },
    },
    {
      dataField: "debutDate",
      text: "Date Debut",
      formatter: (cell) => {
        const options = { year: "numeric", month: "2-digit", day: "2-digit" };
        const date = new Date(cell);
        return date.toLocaleDateString("fr-FR", options).replace(/\//g, "-");
      },
    },
    {
      dataField: "nom",
      text: "Nom",
    },
    {
      dataField: "statut",
      text: "Statut",
      formatter: (cellContent, row) => {
        if (row && row.statut === "terminé") {
          return <span className="badge badge-danger">{cellContent}</span>;
        } else {
          return <span className="badge badge-success">{cellContent}</span>;
        }
      },
    },
    {
      dataField: "actions",
      text: "Actions",
      csvExport: false,
      formatter: (cellContent, row) => {
        return (
          <>
            <div className="d-flex justify-content-center">
              <Button
                variant="secondary"
                className="mr-2"
                onClick={() =>
                  navigate(`/Campagne/PageCampagneE/Edit/${row.id}`)
                }
              >
                <i className="fas fa-edit"></i>
              </Button>{" "}
              <Button
                variant="dark"
                className="mr-2"
                onClick={() => handleDeleteCampagne(row)}
              >
                <i className="fas fa-trash"></i>
              </Button>{" "}
              <Button
                variant="secondary"
                onClick={() =>
                  navigate(`/Campagne/PageCampagneE/Voir/${row.id}`)
                }
              >
                <i className="fas fa-chart-pie"></i>
              </Button>
            </div>
          </>
        );
      },
    },
  ];
  // /.columns-campagne
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">Campagne - Email</h1>
            </div>
            <div className="col-sm-6">
              {/* <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <a href="/">Marketing</a>
                </li>
                <li className="breadcrumb-item">
                  <a href="/Campagne">Campagne</a>
                </li>
                <li className="breadcrumb-item active">Email</li>
              </ol> */}
            </div>
          </div>
        </div>
      </div>
      {/* /.content-header */}
      <section className="content">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div class="card card-dark">
                <div class="card-body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="card-deck">
                        <Card className="Campagne-card-filter">
                          <Card.Body>
                            <div className="row">
                              <div className="col">
                                <div className="row">
                                  {/* StartDate */}
                                  <div className="col-md-3 ">
                                    <div className="form-group">
                                      {" "}
                                      <label htmlFor="startDate">
                                        Date Debut{" "}
                                      </label>
                                      <br/>
                                      <TextField
                                        variant="outlined"
                                        value={filter.debutDate}
                                        onChange={onChangeStartDate}
                                        id="datetime-local"
                                        type="datetime-local"
                                        defaultValue="date"
                                        InputLabelProps={{
                                          shrink: true,
                                        }}
                                        size="small"
                                        className="mt-2"
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-3">
                                    <div className="form-group">
                                      <label htmlFor="endDate">Date Fin </label>
                                      <br/>
                                      <TextField
                                        variant="outlined"
                                        value={filter.finDate}
                                        onChange={onChangeEndDate}
                                        id="datetime-local"
                                        type="datetime-local"
                                        defaultValue="date"
                                        InputLabelProps={{
                                          shrink: true,
                                        }}
                                        size="small"
                                        className="mt-2"
                                      />
                                    </div>
                                    {/* /.EndDate */}
                                  </div>
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <label>Statut</label>
                                      <select
                                        className="custom-select mt-2"
                                        name="statut"
                                        value={filter.statut}
                                        onChange={handleFilterChange}
                                      >
                                        <option value="">All</option>
                                        {statutsData.map((statut) => (
                                          <option key={statut} value={statut}>
                                            {statut}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Card.Body>
                        </Card>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          {/* /.filtre */}

          {/* table */}
          {/* <Divider /> */}
          <ToolkitProvider>
            {(props) => (
              <>
                <div className="row mt-2">
                  <div className="col-md-12">
                    <Card className="pb-3">
                      <Card.Body>
                        {/* table-button */}
                        <div className="d-flex justify-content-end align-items-center mb-3">
                          <div className="input-container">
                            {/* SearchData */}
                            <div className="p-2">
                              <div className="input-group">
                                <input
                                  className="form-control "
                                  type="search"
                                  placeholder="Search"
                                  aria-label="Search"
                                  name="nom"
                                  value={filter.nom}
                                  onChange={handleFilterChange}
                                />
                              </div>
                            </div>

                            {/* /.SearchData */}
                            {/* ExportCSV button */}
                            <div className="p-2">
                              <Button
                                onClick={handleExportCSV}
                                variant="dark"
                                className="my-custom-class Exporter input-container"
                              >
                                Exporter CSV
                              </Button>
                            </div>
                            {/* /.ExportCSV button */}
                            {/* Ajouter button */}
                            <div className="p-2">
                              <Button
                                className="my-custom-class input-container"
                                variant="secondary"
                                onClick={() =>
                                  navigate(
                                    "/Campagne/PageCampagneE/AddCampagneE"
                                  )
                                }
                              >
                                Ajouter
                              </Button>
                            </div>
                            {/* /.Ajouter button */}
                          </div>
                        </div>
                        {/* /.table-button */}
                        <div className="table-container thead-dark mb-3">
                          <BootstrapTable
                            keyField="id"
                            hover
                            condensed
                            pagination={paginationFactory(options)}
                            defaultSorted={[
                              { dataField: "createdDate", order: "asc" },
                            ]}
                            faultSortDirection="asc"
                            noDataIndication={() => "No data found"}
                            data={data}
                            columns={columns}
                            headerClasses="thead-dark"
                          />
                        </div>
                        {/* DeleteModal */}
                        <Modal show={show} onHide={handleClose} centered>
                          <Modal.Header>
                            <Modal.Title>
                              Confirmation de suppression
                            </Modal.Title>
                            <button className="close">
                              <FontAwesomeIcon
                                icon={faTimes}
                                closeButton
                                onClick={handleClose}
                              />
                            </button>
                          </Modal.Header>
                          <Modal.Body>
                            Êtes-vous sûr(e) de vouloir supprimer ?<br />
                            <br />
                            <strong>Date de creation : </strong>
                            {selectedRow && selectedRow.createdDate && (
                              <>
                                {new Date(selectedRow.createdDate)
                                  .toLocaleDateString("fr-FR", {
                                    year: "numeric",
                                    month: "2-digit",
                                    day: "2-digit",
                                  })
                                  .replace(/\//g, "-")}
                              </>
                            )}
                            <br />
                            <strong>Nom : </strong>
                            {selectedRow && selectedRow.nom}
                            <br />
                            <br />
                            <br />
                            <p>
                              Tapper le mot <strong>DELETE</strong> pour pouvez
                              supprimer Data
                            </p>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="DELETE"
                              value={inputValue}
                              onChange={handleInputChangeDelete}
                            />
                          </Modal.Body>
                          <Modal.Footer>
                            <Button variant="secondary" onClick={handleClose}>
                              Annuler
                            </Button>
                            <Button
                              variant="danger"
                              onClick={handleConfirmDelete}
                              disabled={buttonDisabled}
                            >
                              Supprimer
                            </Button>
                          </Modal.Footer>
                        </Modal>
                        {/* /.DeleteModal */}
                      </Card.Body>
                    </Card>
                  </div>
                </div>
                {/* /.table */}
              </>
            )}
          </ToolkitProvider>
        </div>
        {/* /.container-fluid */}
      </section>
      {/* /.content */}
    </div>
  );
}

export default PageCampagneE;
